module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0008#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0009#intro"
    }
  }, [_vm._v("Introduction: Guerrilla Marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0010#story01"
    }
  }, [_vm._v("Omar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0011#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.")]), _vm._v(" An Archaeology of Media Spectacle, 1974–2008")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0012#story02"
    }
  }, [_vm._v("Juana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0013#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.")]), _vm._v(" Operation Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0014#story03"
    }
  }, [_vm._v("Gabriel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0015#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.")]), _vm._v(" Operation Genuine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0016#story04"
    }
  }, [_vm._v("Claudia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0017#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.")]), _vm._v(" The Good Life Deferred and Risks of Remobilization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0018#story05"
    }
  }, [_vm._v("Sergio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0019#conc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CONCLUSION:")]), _vm._v(" The Colombian Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0020#story06"
    }
  }, [_vm._v("Diego")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0021#epil"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("EPILOGUE:")]), _vm._v(" Target Intimacy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0022#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0023#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0024#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifattal0025#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db07b5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-fattal-0007.vue
// module id = 72
// module chunks = 0